"use strict";


const axios = require('axios');


class Form {
    constructor() {

    }

    static get_form_delivery() {
        return {
            id: null,
            user: null,
            order: null,
            stockage_area: null,
            attached_to: null,
            client: null,
            default_client: null,
            phone: null,
            adress: null,
            default_phone: null,
            default_address: null,
            status: null,
            season: null,
            date: null,
            delivery_date: null,
            cost: null,
            tax: null,
            number: null,
            notes: null,
            cgv: null,
            internal_notes: null,
            external_notes: null,
        }
    }

    static get_form_receipt() {
        return {
            id: null,
            user: null,
            transaction: null,
            status: null,
            date: null,
            stockage_area: null,
            attached_to: null,
            client: null,
            default_client: null,
            phone: null,
            address: null,
            default_phone: null,
            default_address: null,
            season: null,
            delivery_date: null,
            cost: null,
            tax: null,
            number: null,
            cgv: null,
            internat_notes: null,
            external_references: null,
            purchase_order: null,
        }
    }

    static get_form_price() {
        return {
            id: null,
            user: null,
            name: null,
            description: null,
            price_level: null,
            order: null,
            active: null,
            company: null,
            price: null,
            sku: null,
        }
    }

    static get_form_product() {
        return {
            id: null,
            name: null,
            reference: null,
            description: null,
            manufacturer_description: null,
            cost_price: null,
            buying_price: null,
            saling_price: null,
            weigth: null,
            tax_amount: null,
            type: null,
            category: null,
            prices: null,
            adviced_price: null,
            manufacturer: null,
            product: null,
            sku: null,
            barcode: null,
            sh_code: null,
            stock: null,
            stock_alert: null,
            supply_alert: null,
            expiration_date: null,
            optimal_consumption_date: null,
            tags: null,
            service: null,
            origin_country: null,
            brand: null,
            season: null,
            price_level: null,
            discount: null,
            currency: null,
        }
    }

    static get_form_product_variation() {
        return {
            id: null,
            user: null,
            name: null,
            description: null,
            cost_price: null,
            saling_price: null,
            tax_amount: null,
            product: null,
            adviced_price: null,
            company: null,
            weight: null,
            stock: null,
            stock_alert: null,
            supply_stock: null,
            prices: null,
            barcode: null,
            sku: null,
            photo: null,
        }
    }

    static get_form_purchase_order() {
        return {
            id: null,
            user: null,
            client: null,
            attached_to: null,
            internal_notes: null,
            date: null,
            delivery_date: null,
            delivery_cost: null,
            delivery_tax: null,
            company: null,
            number: null,
            external_references: null,
            default_manufacturer: null,
            manufacturer: null,
            status: null,
            season: null,
            stockage_area: null,
            price_level: null,
            tax_type: false,
            currency: null,
            tax: null,

        }
    }

    static get_form_client_delivery() {
        return {
            id: null,
            default: null,
            editable: null,
            user: null,
            order: null,
            stockage_area: null,
            attached_to: null,
            client: null,
            default_client: null,
            phone: null,
            address: null,
            default_phone: null,
            default_address: null,
            status: null,
            season: null,
            date: null,
            delivery_date: null,
            company: null,
            cost: null,
            tax: null,
            number: null,
            cgv: null,
            internal_notes: null,
            external_references: null,

        }
    }

}

module.exports.Form = Form;